import CreateApiKeysStore from '../stores/create-api-key-store';

export const closeCreateApiKeyModal = (): void => {
  clearErrorMessage();
  setModalVisibility(false);
  clearKeySecret();
};

export const openCreateApiKeyModal = (): void => {
  setModalVisibility(true);
};

const setModalVisibility = (payload: boolean): void => {
  CreateApiKeysStore.isModalVisible = payload;
};

export const clearErrorMessage = () => {
  CreateApiKeysStore.errorMessage = null;
};

export const setErrorMessage = (msg: string) => {
  CreateApiKeysStore.errorMessage = msg;
};

export const setLoadingCreateApiKey = (isLoading: boolean) => {
  CreateApiKeysStore.isLoading = isLoading;
};

export const setKeySecret = (keySecret: string) => {
  CreateApiKeysStore.keySecret = keySecret;
};

export const clearKeySecret = () => {
  CreateApiKeysStore.keySecret = null;
};
